module.exports = __webpack_public_path__ + "img/20-1.58728f2d.png";